var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 24.444,
    viewBox: "0 0 22 24.444",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .a{fill:#000FFF;}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M11.556,20.333V16.667H3V11.778h8.556V8.111l6.111,6.111-6.111,6.111M11.556,2h11A2.444,2.444,0,0,1,25,4.444V24a2.444,2.444,0,0,1-2.444,2.444h-11A2.444,2.444,0,0,1,9.111,24V21.556h2.444V24h11V4.444h-11V6.889H9.111V4.444A2.444,2.444,0,0,1,11.556,2Z",
    transform: "translate(-3 -2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.cdd962b547d369f2d10e82dd36621fcb.svg";
export { ForwardRef as ReactComponent };